import { Slides } from '@/helpers/slides'

const logger = (x, d = 'log', dev = 0) => dev && d//console[d](x)

export async function metaBeforeEnter(alias, titles, hasEntry = true) {
    // Current slides' page based on a url-path
    const { path } = this.$route
    const currentSlide = alias.findIndex(slide => slide === path)

    // Update meta tags
    hasEntry && Slides.updatePageMeta(currentSlide, alias, titles, false)

    return currentSlide
}

export async function slidesBeforeEnter(alias, titles, hasEntry = true) {
    if ( this.isMobile() )
        this.rootClass('rm', '-viewport')
    else
        this.rootClass('add')

    const i = await metaBeforeEnter.call(this, alias, titles, hasEntry)

    // Set current slides' {i}
    await this.$store.dispatch(`${this.moduleType}/slideSetup`, {
        i,
        duration: 0,
    })

    // Set current slides' {offset}
    await slidesPreset.call(this, i, alias, titles)

    return setTimeout(() => {
        this.disableFocusables( i )
    }, 10)
}

export async function slidesPreset( slide, alias, titles, duration, delta = 1 ) {

    if ( this.isMobile() ) return;

    logger({
        name: 'slidePreset', 
        prevSlide: slide, 
        currentSlide: this.$store.state.discover.current.slide
    })

    const isDiscover = !titles.some(el => el.toLowerCase().includes('recruit'))

    // Update slides' {offset} 
    Slides.setMainOffset({
        method: 'set',
        slides: this.$refs.slides,
        offset: this.$store.state.browser.width * -slide, 
        duration, 
    })

    // Update slides' {parallax}
    return Slides.setElemsOffset({
        method: 'set',
        slides: this.slides,
        currentSlide: slide, 
        delta, 
        isDiscover,
    })
}

export async function slidesParallax( slide, alias, titles, duration, delta = 1 ) {

    if ( this.isMobile() ) return;
    
    logger({
        name: 'slidesParallax',
        slide,
    })
    
    // Delegate update slides' {meta}
    const onComplete = () => {
        Slides.updatePageMeta(slide, alias, titles, true)
    }

    // Update slides' {offset} 
    Slides.setMainOffset({
        slides: this.$refs.slides,
        offset: this.offset, 
        duration, 
        onComplete
    })

    const isDiscover = !titles.some(el => el.toLowerCase().includes('recruit'))

    // Update slides' {parallax}
    return Slides.setElemsOffset({
        slides: this.slides,
        currentSlide: this.currentSlide, 
        delta, 
        duration, 
        isDiscover,
    })
}